import React, { useState } from 'react';

import classNames from 'classnames';

import { formatFigure } from 'Helpers/formatService';

import CheckboxInput from 'CommonComponents/CheckboxInput';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

export default function UncommittedExpenditureCreateListRow(props) {
    const [uncommittedExpenditure] = useState(props.uncommittedExpenditure);
    const [showChildren, setShowChildren] = useState(props.showChildren || false);

    const clickRow = () => {
        setShowChildren(!showChildren);
    };

    const clickCheck = (e) => {
        if (e.target.checked) {
            let updatedCommittedExpenditures = props.committedExpenditures;
            if (uncommittedExpenditure.childrenCashflow && uncommittedExpenditure.childrenCashflow.length > 0) {
                uncommittedExpenditure.childrenCashflow.forEach((uncommittedExpenditureChild) => {
                    // For pack child add if
                    // It does not already exists
                    // Or if it already exists against a pack but not against current pack
                    if (
                        uncommittedExpenditureChild.model === 'pack_child' &&
                        (!updatedCommittedExpenditures.some((item) => item.id === uncommittedExpenditureChild.id) ||
                            (updatedCommittedExpenditures.some((item) => item.id === uncommittedExpenditureChild.id) &&
                                !updatedCommittedExpenditures.some((item) => {
                                    return item.id === uncommittedExpenditureChild.id && item.expense_id === uncommittedExpenditureChild.expense_id;
                                })))
                    ) {
                        updatedCommittedExpenditures.push(uncommittedExpenditureChild);
                    } else if (!updatedCommittedExpenditures.some((item) => item.id === uncommittedExpenditureChild.id)) {
                        updatedCommittedExpenditures.push(uncommittedExpenditureChild); // For all other expense types only add if not already in the array
                    }
                });

                // Force expand the children when selecting all
                if (!showChildren) {
                    setShowChildren(true);
                }

                // Wait for DOM to update after expanding children
                setTimeout(() => {
                    uncommittedExpenditure.childrenCashflow.forEach((uncommittedExpenditureChild) => {
                        if (uncommittedExpenditureChild.checkable) {
                            const checkboxId = 'uncommmitted-expenditure-checkbox-' + uncommittedExpenditureChild.id;
                            const checkbox = document.getElementById(checkboxId);
                            if (checkbox) {
                                checkbox.checked = true;
                            }
                        }
                    });
                }, 0);
            } else {
                // Only add if not already in the array
                if (!updatedCommittedExpenditures.some((item) => item.id === uncommittedExpenditure.id)) {
                    updatedCommittedExpenditures.push(uncommittedExpenditure);
                }

                // Check template expense if all checkable children are already selected
                checkAndSelectParentTemplate(updatedCommittedExpenditures);
            }
            props.setCommittedExpenditures(updatedCommittedExpenditures);
        } else {
            let updatedCommittedExpenditures = props.committedExpenditures;
            if (uncommittedExpenditure.childrenCashflow && uncommittedExpenditure.childrenCashflow.length > 0) {
                // Force expand the children when selecting all
                if (!showChildren) {
                    setShowChildren(true);
                }

                uncommittedExpenditure.childrenCashflow.forEach((uncommittedExpenditureChild) => {
                    updatedCommittedExpenditures.splice(
                        props.committedExpenditures.findIndex((element) => element.id == [uncommittedExpenditureChild.id]),
                        1,
                    );
                });

                uncommittedExpenditure.childrenCashflow.forEach((uncommittedExpenditureChild) => {
                    if (uncommittedExpenditureChild.checkable) {
                        const checkboxId = 'uncommmitted-expenditure-checkbox-' + uncommittedExpenditureChild.id;
                        const checkbox = document.getElementById(checkboxId);
                        if (checkbox) {
                            checkbox.checked = false;
                        }
                    }
                });
            } else {
                updatedCommittedExpenditures.splice(
                    props.committedExpenditures.findIndex((element) => element.id == [e.target.value]),
                    1,
                );

                // Check template expense if all checkable children are already selected
                checkAndSelectParentTemplate(updatedCommittedExpenditures);
            }
            props.setCommittedExpenditures(updatedCommittedExpenditures);
        }
    };

    const getCheckableChildren = () => {
        const { childrenCashflow } = uncommittedExpenditure;
        if (!childrenCashflow || childrenCashflow.length === 0) {
            return;
        }

        let checkableChildren = [];
        if (uncommittedExpenditure.model === 'project') {
            uncommittedExpenditure.childrenCashflow.map((childCashflow) => {
                let newChildCashflow =
                    !childCashflow.childrenCashflow || childCashflow.childrenCashflow?.length === 0
                        ? childCashflow.checkable
                            ? [childCashflow]
                            : []
                        : childCashflow.childrenCashflow;
                checkableChildren = [...checkableChildren, ...newChildCashflow];
            });
        } else {
            checkableChildren = childrenCashflow.filter((child) => child.checkable);
        }

        return checkableChildren;
    };

    const clickSelectAll = (e) => {
        e.stopPropagation();

        // Only proceed if we have children
        const { childrenCashflow } = uncommittedExpenditure;
        if (!childrenCashflow || childrenCashflow.length === 0) {
            return;
        }

        // Force expand the children when selecting all
        const needsExpansion = !showChildren;
        if (needsExpansion) {
            setShowChildren(true);
        }

        let updatedCommittedExpenditures = [...props.committedExpenditures];

        // Get only checkable children
        const checkableChildren = getCheckableChildren();

        // Check if all checkable children are already selected
        const allSelected = checkableChildren.every((child) => updatedCommittedExpenditures.some((item) => item.id === child.id));
        if (allSelected) {
            // If all are selected, deselect all checkable children
            updatedCommittedExpenditures = updatedCommittedExpenditures.filter((item) => !checkableChildren.some((child) => child.id === item.id));
        } else {
            // If not all selected, select all checkable children that aren't already selected
            checkableChildren.forEach((child) => {
                if (!updatedCommittedExpenditures.some((item) => item.id === child.id)) {
                    updatedCommittedExpenditures.push(child);
                }
            });
        }

        props.setCommittedExpenditures(updatedCommittedExpenditures);

        // Manually update checkbox states by simulating clicks
        // If we expanded children, wait longer for DOM to update (React needs time to render)
        const timeoutDelay = needsExpansion ? 100 : 0;
        setTimeout(() => {
            let checkableUncommittedExpenditures =
                uncommittedExpenditure.model === 'project' ? uncommittedExpenditure.childrenCashflow.filter((child) => child.checkable) : checkableChildren;

            checkableUncommittedExpenditures.forEach((child) => {
                const checkboxId = 'uncommmitted-expenditure-checkbox-' + child.id;
                const checkbox = document.getElementById(checkboxId);

                if (checkbox) {
                    // Set the checked property to match the desired state
                    const shouldBeChecked =
                        uncommittedExpenditure.model === 'project' ? !allSelected : updatedCommittedExpenditures.some((item) => item.id === child.id);

                    // Only change if the current state doesn't match the desired state
                    if (checkbox.checked !== shouldBeChecked) {
                        // Manually set the checked property
                        checkbox.checked = shouldBeChecked;
                    }
                }

                if (uncommittedExpenditure.model === 'project' && child.childrenCashflow && child.childrenCashflow.length > 0) {
                    let checkableChildUncommittedExpenditures = child.childrenCashflow.filter((innerChild) => innerChild.checkable);
                    checkableChildUncommittedExpenditures.forEach((childUncommittedExpenditure) => {
                        const checkboxId = 'uncommmitted-expenditure-checkbox-' + childUncommittedExpenditure.id;
                        const checkbox = document.getElementById(checkboxId);

                        if (checkbox) {
                            // Set the checked property to match the desired state
                            const shouldBeChecked = !allSelected;

                            // Only change if the current state doesn't match the desired state
                            if (checkbox.checked !== shouldBeChecked) {
                                // Manually set the checked property
                                checkbox.checked = shouldBeChecked;
                            }
                        }
                    });

                    child.childrenCashflow.forEach((childUncommittedExpenditure) => {
                        if (childUncommittedExpenditure.model === 'template') {
                            toggleTemplateExpense(childUncommittedExpenditure, updatedCommittedExpenditures);
                        }
                    });
                }
            });
        }, timeoutDelay);
    };

    const allSelected = () => {
        const { childrenCashflow } = uncommittedExpenditure;
        if (!childrenCashflow || childrenCashflow.length === 0) {
            return false;
        }

        // Get only checkable children
        const checkableChildren = getCheckableChildren();

        // Check if all checkable children are already selected
        return checkableChildren.every((child) => props.committedExpenditures.some((item) => item.id === child.id));
    };

    const findParentTemplate = () => {
        if (!props.uncommittedExpenditures || uncommittedExpenditure.model !== 'template_child') {
            return null;
        }

        // If the tree has projects, search their children and return the matching template expense
        const projectTemplate = props.uncommittedExpenditures
            .filter((expenditure) => expenditure.model === 'project' && Array.isArray(expenditure.childrenCashflow))
            .flatMap((expenditure) => expenditure.childrenCashflow)
            .find(
                (childExpenditure) =>
                    childExpenditure.model === 'template' &&
                    childExpenditure.childrenCashflow &&
                    childExpenditure.childrenCashflow.some((child) => child.id === uncommittedExpenditure.id),
            );

        if (projectTemplate) {
            return projectTemplate;
        }

        // Otherwise, search top-level templates
        return props.uncommittedExpenditures.find(
            (expenditure) =>
                expenditure.model === 'template' &&
                expenditure.childrenCashflow &&
                expenditure.childrenCashflow.some((child) => child.id === uncommittedExpenditure.id),
        );
    };

    const checkAndSelectParentTemplate = (updatedCommittedExpenditures) => {
        if (uncommittedExpenditure.model !== 'template_child') {
            return;
        }

        const parentTemplate = findParentTemplate();
        if (!parentTemplate || !parentTemplate.childrenCashflow) {
            return;
        }

        updatedCommittedExpenditures = toggleTemplateExpense(parentTemplate, updatedCommittedExpenditures);

        return updatedCommittedExpenditures;
    };

    const toggleTemplateExpense = (parentTemplate, updatedCommittedExpenditures) => {
        // Get all checkable template_child items from the parent template
        const checkableTemplateChildren = parentTemplate.childrenCashflow.filter((child) => child.checkable);
        if (checkableTemplateChildren.length === 0) {
            return;
        }

        // Check if all checkable template_child items are selected
        const allTemplateChildrenSelected = checkableTemplateChildren.every((child) => updatedCommittedExpenditures.some((item) => item.id === child.id));

        // If all are selected and parent template is not already selected, add it
        const checkboxId = 'uncommmitted-expenditure-checkbox-' + parentTemplate.id;
        const checkbox = document.getElementById(checkboxId);
        if (checkbox) {
            checkbox.checked = allTemplateChildrenSelected;
        }

        return updatedCommittedExpenditures;
    };

    return (
        <>
            <tr
                key={uncommittedExpenditure.id}
                className={classNames({
                    '!tw-bg-white': props.level === 2,
                    '!tw-bg-[#F3F7FF]': props.level === 3,
                    'tw-cursor-pointer': !uncommittedExpenditure.checkable,
                })}
            >
                <td className="!tw-border-r-0">
                    {uncommittedExpenditure.checkable && (
                        <CheckboxInput
                            id={'uncommmitted-expenditure-checkbox-' + uncommittedExpenditure.id}
                            defaultChecked={false}
                            value={uncommittedExpenditure.id}
                            onChange={(e) => clickCheck(e)}
                        />
                    )}
                    {!uncommittedExpenditure.checkable && uncommittedExpenditure.childrenCashflow && uncommittedExpenditure.childrenCashflow.length > 0 && (
                        <button className="tw-text-xs tw-font-semibold tw-underline" onClick={(e) => clickSelectAll(e)}>
                            {allSelected() ? $t('Deselect all') : $t('Select all')}
                        </button>
                    )}
                </td>
                <td
                    className={classNames('tw-font-semibold', {
                        '!tw-pl-6 !tw-font-medium': props.level === 2,
                        '!tw-pl-9 !tw-font-normal': props.level === 3,
                    })}
                >
                    {uncommittedExpenditure.childrenCashflow && uncommittedExpenditure.childrenCashflow.length > 0 ? (
                        <div className="tw-flex tw-items-center tw-gap-x-1.5 tw-cursor-pointer" onClick={clickRow}>
                            <div>{uncommittedExpenditure.name}</div>
                            {showChildren ? <ChevronUpIcon className="tw-w-1.5 tw-h-1.5" /> : <ChevronDownIcon className="tw-w-1.5 tw-h-1.5" />}
                        </div>
                    ) : (
                        uncommittedExpenditure.name
                    )}
                </td>
                <td className="inbud-numeric-cell">{formatFigure(uncommittedExpenditure.cash)}</td>
                {props.vikEnabled && <td className="inbud-numeric-cell">{formatFigure(uncommittedExpenditure.vik)}</td>}
                <td className="inbud-numeric-cell">{formatFigure(uncommittedExpenditure.total)}</td>
                <td className="inbud-numeric-cell">{formatFigure(uncommittedExpenditure.committed)}</td>
                <td className="inbud-numeric-cell">{formatFigure(uncommittedExpenditure.uncommitted)}</td>
            </tr>
            {showChildren && uncommittedExpenditure.childrenCashflow && uncommittedExpenditure.childrenCashflow.length > 0 && (
                <>
                    {uncommittedExpenditure.childrenCashflow.map((childCashflow) => {
                        return (
                            <UncommittedExpenditureCreateListRow
                                key={childCashflow.model + '_' + childCashflow.id}
                                uncommittedExpenditure={childCashflow}
                                uncommittedExpenditures={props.uncommittedExpenditures}
                                committedExpenditures={props.committedExpenditures}
                                setCommittedExpenditures={props.setCommittedExpenditures}
                                level={props.level === 2 ? 3 : 2}
                                vikEnabled={props.vikEnabled}
                                showChildren={showChildren}
                            />
                        );
                    })}
                </>
            )}
        </>
    );
}
